<template>
  <div class="about-page" :class="{ 'about-page--en': !isAr }">
    <!-- aboutus intro: split hero — text / art columns -->
    <section class="aboutusIntro" :class="{ 'about-hero--en': !isAr }">
      <b-container fluid class="px-0">
        <b-row
          no-gutters
          class="about-hero-split intro-section align-items-stretch mx-0"
          :class="{ 'flex-xl-row-reverse': isAr }"
        >
          <b-col
            cols="12"
            xl="6"
            class="about-hero-copy d-flex align-items-center py-5 px-4 px-xl-5"
          >
            <div class="about-hero-text w-100">
              <h1 class="mb-3"><b>{{ langDec.about_intro_title }}</b></h1>
              <p class="mb-0">{{ langDec.about_intro_subtitle }}</p>
            </div>
          </b-col>
          <b-col cols="12" xl="6" class="about-hero-art p-0" aria-hidden="true" />
        </b-row>
      </b-container>
    </section>

    <!-- ceo -->
    <section class="ceo">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col
            xl="8"
            lg="8"
            md="12"
            class="ceo-text-col d-flex align-items-center"
          >
            <div class="text-section">
              <div>
                <div class="title">
                  <span class="title-green">{{ langDec.about_founder_label }}</span>
                  <h2 class="name">
                    {{ langDec.about_founder_name }}
                  </h2>
                  <span class="pref">{{ langDec.about_founder_role }}</span>
                </div>
                <p class="ceo-bio">
                  {{ langDec.about_founder_bio }}
                </p>
                <span class="link">
                  <b-link @click="goToRoute('abouCEO')">{{ langDec.articles_read_more }}</b-link>
                </span>
              </div>
            </div>
          </b-col>
          <b-col
            xl="4"
            lg="4"
            md="12"
            class="ceo-photo-col d-flex justify-content-center align-items-center"
          >
            <div class="img-section">
              <img
                width="250"
                height="250"
                src="../assets/images/ceoPhoto.png"
                alt=""
              >
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- message-section -->
    <section>
      <div class="message-section">
        <b-row class="container-fluid message-section__row pb-5">
          <b-col xl="7" lg="7" md="12" class="message-section__text-wrap">
            <div class="message-section__inner pt-5 mt-5 px-4">
              <h3 class="mb-5 about-message-title">
                {{ langDec.about_message_title }}
              </h3>
              <div class="about-message-body">
                <p class="mb-4">
                  {{ langDec.about_message_p1 }}
                </p>
                <p class="mb-4">
                  {{ langDec.about_message_p2 }}
                </p>
                <p class="mb-4">
                  {{ langDec.about_message_p3 }}
                </p>
                <p>
                  <b>
                    {{ langDec.about_message_quote_intro }}
                    <br>
                    {{ langDec.about_message_quote }}
                  </b>
                </p>
              </div>
            </div>
          </b-col>
          <b-col class="mb-6 message-section__img-wrap">
            <div class="message-section__img-holder">
              <img
                class="message-section__img"
                src="../assets/images/msgaboutus.png"
                alt=""
              >
            </div>
          </b-col>
        </b-row>

        <!-- appbtns — grouped; flex-start follows html dir (AR→right, EN→left) -->
        <b-row v-if="googleplay || applestore" class="container-fluid about-store-row mx-0">
          <b-col cols="12" class="about-stores-col px-3">
            <div class="about-hero-stores">
                  <b-button
                    v-if="applestore"
                    class="carousel-btn carousel-btn-1 about-store-btn px-4 py-2 mb-2"
                    variant="dark"
                    @click="goTowebsite(applestore)"
                  >
                    <div
                      class="store-badge-inner carousel-btn-in-div px-3"
                      :class="{ 'store-badge-inner--en': !isAr }"
                    >
                      <div class="store-badge-inner__icon store-badge-inner__icon--apple">
                        <img
                          class="store-badge-inner__apple-img"
                          src="../assets/images/Apple_logo_white.svg.png"
                          alt=""
                        >
                      </div>
                      <div class="carousel-btn-in-div-text store-badge-inner__text">
                        <span>{{ langDec.nav_available_on }}</span>
                        <br>
                        <span>App Store </span>
                      </div>
                    </div>
                  </b-button>
                  <b-button
                    v-if="googleplay"
                    class="carousel-btn carousel-btn-2 about-store-btn px-4 py-2 mb-2"
                    variant="primary"
                    @click="goTowebsite(googleplay)"
                  >
                    <div
                      class="store-badge-inner px-3"
                      :class="{ 'store-badge-inner--en': !isAr }"
                    >
                      <div class="store-badge-inner__icon store-badge-inner__icon--google">
                        <svg
                          class="kOqhQd"
                          aria-hidden="true"
                          viewBox="0 0 40 40"
                          xmlns="http://www.w3.org/2000/svg"
                        ><path fill="none" d="M0,0h40v40H0V0z" /><g><path d="M19.7,19.2L4.3,35.3c0,0,0,0,0,0c0.5,1.7,2.1,3,4,3c0.8,0,1.5-0.2,2.1-0.6l0,0l17.4-9.9L19.7,19.2z" fill="#EA4335" /><path d="M35.3,16.4L35.3,16.4l-7.5-4.3l-8.4,7.4l8.5,8.3l7.5-4.2c1.3-0.7,2.2-2.1,2.2-3.6C37.5,18.5,36.6,17.1,35.3,16.4z" fill="#FBBC04" /><path d="M4.3,4.7C4.2,5,4.2,5.4,4.2,5.8v28.5c0,0.4,0,0.7,0.1,1.1l16-15.7L4.3,4.7z" fill="#4285F4" /><path d="M19.8,20l8-7.9L10.5,2.3C9.9,1.9,9.1,1.7,8.3,1.7c-1.9,0-3.6,1.3-4,3c0,0,0,0,0,0L19.8,20z" fill="#34A853" /></g></svg>
                      </div>
                      <div class="carousel-btn-in-div-text store-badge-inner__text">
                        <span>{{ langDec.nav_available_on }}</span>
                        <br>
                        <span>Google Play</span>
                      </div>
                    </div>
                  </b-button>
            </div>
          </b-col>
        </b-row>
      </div>
    </section>

    <!-- value -->
    <section class="value">
      <b-container fluid>
        <b-row class="justify-content-around">
          <b-col xl="12" lg="12" md="12" class="value-heading-col d-flex align-items-center justify-content-center text-center">
            <div class="text-section">
              <div>
                <div class="title">
                  <span class="title-green">{{ langDec.about_goal_label }}</span>
                  <h2 class="name">
                    {{ langDec.about_goal_title }}
                  </h2>
                </div>
                <p class="value-body">
                  {{ langDec.about_goal_body }}
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-container>
    </section>

    <!-- experts carousel -->
    <section>
      <expert-carousel :key="'about-experts-' + currentLang" />
    </section>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import expertCarousel from "../components/ExpertCarousel.vue";

export default {
  name: "AboutUs",
  components: {
    expertCarousel,
  },
  data() {
    return {
      googleplay: process.env.VUE_APP_GOOGLEPLAYLINK,
      applestore: process.env.VUE_APP_APPLESTORELINK,
    };
  },
  computed: {
    ...mapGetters(["getLangData", "getlang"]),
    langDec() {
      return this.getLangData || {};
    },
    currentLang() {
      return this.getlang || "ar";
    },
    isAr() {
      return this.currentLang === "ar";
    },
  },
  methods: {
    goToRoute(name) {
      this.$router.push({ name }).catch(() => {});
    },
    goTowebsite(link) {
      window.open(link, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.about-page {
  color: inherit;
}

/* Split hero — copy + art (no overlap); full vector in AR via contain */
.aboutusIntro .about-hero-split {
  min-height: 450px;
}

.about-hero-art {
  min-height: 280px;
  background-color: #0d7a45;
  background-image: linear-gradient(rgba(0, 0, 0, 0.42), rgba(0, 0, 0, 0.42)),
    url(../assets/images/aboutUsBG.png);
  background-size: cover;
  background-repeat: no-repeat;
  background-position: left center;
}

.aboutusIntro:not(.about-hero--en) .about-hero-art {
  background-size: contain;
  background-position: center center;
}

.about-hero-copy {
  background: linear-gradient(160deg, #054d2a 0%, #006633 42%, #0a7a44 100%);
  color: #fff;
}

.about-hero-text {
  text-align: start;
}

.about-hero-text h1 {
  font-size: 2.25rem !important;
  font-weight: bolder !important;
  line-height: 1.2;
  color: #fff !important;
}

.about-hero-text p {
  font-size: 1.125rem;
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.96) !important;
}

@media (min-width: 1200px) {
  .about-hero-art {
    min-height: 450px;
  }

  .about-hero-text h1 {
    font-size: 2.5rem !important;
  }

  .about-hero-text p {
    font-size: 1.2rem;
  }
}

@media (max-width: 991.98px) {
  .aboutusIntro .about-hero-split {
    min-height: 0;
  }

  .about-hero-art {
    min-height: 260px;
  }
}

@media (max-width: 767.98px) {
  .about-hero-art {
    min-height: 220px;
  }

  .about-hero-text h1 {
    font-size: 1.75rem !important;
  }
}

/* ceo */
.ceo {
  padding: 80px 20px;
}

.ceo .text-section {
  display: flex;
  align-items: center;
  margin-inline-end: 70px;
}

.ceo-text-col {
  text-align: start;
}

.ceo-bio {
  max-width: 40rem;
}

.ceo .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.ceo .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 10px;
  font-weight: bold;
}

.ceo .text-section .pref {
  font-size: 16px;
  color: #858585;
}

.ceo .text-section p {
  margin-top: 30px;
}

/* message */
.message-section {
  background-image: url(../assets/images/aboutusgreenBG.png);
  background-size: cover;
  background-position: right top;
  padding-inline-end: 40px;
  width: auto;
  color: #fff;
}

.about-page--en .message-section {
  background-position: left top;
}

.message-section__text-wrap {
  margin-top: 20px;
  display: flex;
}

.message-section__inner {
  align-items: flex-start;
  text-align: start;
  margin-bottom: 25px;
}

.about-message-title {
  font-size: 44px;
}

.about-message-body {
  font-size: 20px;
  text-align: start;
}

.message-section__img-holder {
  font-size: 20px;
  text-align: center;
}

.message-section__img {
  width: 320px;
  height: 240px;
  max-width: 100%;
  margin-top: 200px;
}

.about-store-row .about-stores-col {
  margin-bottom: 50px;
}

.about-hero-stores {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem 1rem;
  justify-content: flex-start;
  width: 100%;
}

.about-store-btn {
  margin-left: 0 !important;
  margin-right: 0 !important;
  margin-inline: 0 !important;
}

/* شارات المتجر */
.store-badge-inner {
  display: flex;
  align-items: center;
  justify-content: center;
  direction: ltr;
  gap: 0.875rem;
}

.store-badge-inner--en {
  flex-direction: row-reverse;
}

.store-badge-inner__icon {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.store-badge-inner__icon--apple {
  width: 35px;
  height: 35px;
  color: #fff;
}

.store-badge-inner__icon--google {
  width: 40px;
  height: 40px;
}

.store-badge-inner__apple-img {
  width: 35px;
  height: auto;
  margin-top: -3px;
  display: block;
}

.store-badge-inner__text {
  font-size: 20px;
  line-height: 1.25;
  text-align: start;
}

/* value */
.value {
  padding: 80px 20px;
}

.value-heading-col .text-section {
  display: flex;
  align-items: center;
  border: 1px solid #f08262;
  border-radius: 10px;
  padding: 20px;
  width: 65%;
  max-width: 100%;
}

.value-body {
  text-align: start;
}

.value .text-section .title-green {
  color: #006633;
  font-size: 24px;
}

.value .text-section .name {
  font-size: 32px;
  margin-top: 20px;
  margin-bottom: 30px;
  font-weight: bold;
}

.value .text-section .pref {
  font-size: 16px;
  color: #858585;
}

@media (max-width: 991.98px) {
  .aboutusIntro .about-hero-text h1 {
    font-size: 30px !important;
    font-weight: bolder !important;
  }

  .button-section .btn,
  .about-store-btn {
    font-size: 10px !important;
  }

  .message-section {
    padding-inline-end: 20px;
  }

  .message-section__img {
    margin-top: 2rem;
  }

  .ceo .text-section {
    margin-inline-end: 30px;
    margin-bottom: 50px;
  }

  .value-heading-col .text-section {
    padding: 10px;
    width: 80%;
  }
}

@media (max-width: 767.98px) {
  .message-section {
    padding-inline-end: 5px;
  }

  .value-heading-col .text-section {
    width: 95%;
  }

  .about-message-title {
    font-size: 32px;
  }

  .about-message-body {
    font-size: 18px;
  }
}
</style>
